import React, { useContext } from 'react'
import CompactWorkItem from '@Components/WorkItemV2/CompactWorkItem'
import WorkItemData from '@Components/WorkItemV2/work-item-data'
import ShareDisplay from '@Components/WorkItemV2/ShareDisplay'
import StatusComponent from '@Components/Status'
import HistoryCompactWorkItemHeader from '@Components/WorkItemV2/History/HistoryCompactWorkItem/HistoryCompactWorkItemHeader'
import './index.scss'
import { CardWithHeader } from '@Components/Tables/CardResults/card-with-header'
import { getSubmissionPath } from '@App/helpers/get-submission-path'
import RootStore from '@App/stores/root-store'
import { StoresContext } from '@App/contexts'
import NeedsAttentionActions from '@Components/WorkItemV2/History/NeedsAttentionActions'
import { observer } from 'mobx-react'

const NeedsAttentionCompactWorkItem: CardWithHeader<WorkItemData> = ({ work, fetchType }: WorkItemData) => {
    const { rightsholderStore } = useContext<RootStore>(StoresContext)
    const submissionPath = getSubmissionPath(rightsholderStore.currentRightsholderId, work.id, fetchType)

    return (
        <div className="needs-attention-compact-work-item-wrapper">
            <CompactWorkItem work={work} className="history-work-item" catalogPath={submissionPath}>
                <div className="shares-group">
                    <ShareDisplay share={work.totalKnownShares} title="" highlight />
                </div>
                {work.registrationHistoryStatus && (
                    <StatusComponent
                        status={
                            work.registrationHistoryStatus === 'Unknown' ? 'Submitted' : work.registrationHistoryStatus
                        }
                    />
                )}
            </CompactWorkItem>
            <NeedsAttentionActions work={work} />
        </div>
    )
}

NeedsAttentionCompactWorkItem.headerType = HistoryCompactWorkItemHeader

export default observer(NeedsAttentionCompactWorkItem)
